import React from "react";
// import QueueAnim from "rc-queue-anim";
import { useTranslation } from "react-i18next";
import { Button } from "../../components/Button";
import { CommonConsult } from "../common-consult";
import "./styles.less";

export const CustomerDetailBanner = (props) => {
  const { t } = useTranslation();
  const { title, subtitle, theme, imgUrl, alt, addtionTitle = null } = props;
  return (
    <section>
      <div className="customer-detail-banner-warp">
        <div className="inner">
          <div className="customer-detail-banner">
            <div className="customer-banner-content">
              <h1 key="1" className="banner-title">
                <span>{title}</span>
                <span className="addition">{addtionTitle}</span>
              </h1>
              <div key="2" className="banner-subtitle">
                {subtitle}
                <div style={{ textAlign: "right" }}>
                  ———<span style={{ marginLeft: 4 }}>{title}</span>
                </div>
              </div>
              <span key="3" className="banner-button">
                <CommonConsult
                  aside={
                    <span
                      className="customer-consult-button"
                      style={{ background: theme }}
                    >
                      {t("common.button.consult")}
                    </span>
                  }
                />
              </span>
            </div>
            <div className="banner-img">
              <img src={imgUrl} alt={alt} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
